import { returnAllTradeDetailsFromGenericParams } from "@/lib/agGridColDefs/colDefGlobalHelpers";
import { returnDecimalFormatting } from "@/lib/globalFormatterHelper";
import { InstrumentTypeCode } from "@/lib/interfaces and Enums/ENUMInstrumentTypeCode";
import tradeDataStore from "@/store/tradeDataStore";
import { isStrikeEditable } from "../actionSummaryColDefHelperFunctions";
import { useTheme } from "next-themes";

const StrikeCellRenderer = (params: any) => {
  const data = params.data;

  const { isOp, isOutright, fullTradeData } =
    returnAllTradeDetailsFromGenericParams(params);
  const { theme } = useTheme();

  let valueToReturn: number | undefined = 0;
  const tradeData = tradeDataStore((state) => state.tradeData);
  const thisTrade =
    tradeData.find((trade) => trade.esid == fullTradeData.esid) ??
    fullTradeData;

  // Early return to force a value of 0 - thus conversion to empety sting if not matching the InstrumentCode.
  if (!isOutright) {
    if (!isOp && params.data.instrumentType != InstrumentTypeCode.OPT) {
      return;
    } else if (isOp) {
      if (
        params.data.securityType == "BNDO" ||
        params.data.securityType == "SWO"
      ) {
        //Do nothing.
      } else {
        return;
      }
    }
  }

  let ercpIndex = 0;
  if (isOp) {
    thisTrade?.executionRequestCounterParties?.forEach((trade, index) => {
      if (trade.executionRequestId == data.executionRequestId) {
        ercpIndex = index;
      }
    });
  }
  // let valueToReturn = 0;
  if (thisTrade && thisTrade.executionRequestCounterParties) {
    if (isOp) {
    }
    if (
      (isOutright && params.data.legs?.[0]?.securityType == "BNDO") ||
      (isOutright && params.data.legs?.[0]?.securityType == "SWO")
    ) {
      valueToReturn =
        thisTrade?.executionRequestCounterParties?.[ercpIndex]?.legs?.[0]
          ?.dealtStrike;
    } else if (!isOutright) {
      valueToReturn = params.data.dealtStrike;
    }
  }
  // NOW RP - If there are NO exectionCounterparties, it's the RP.
  if (thisTrade && !isOp) {
    if (!isOutright) {
      valueToReturn = params.data.dealtStrike;
    } else {
      if (thisTrade?.legs && thisTrade.legs.length > 0) {
        valueToReturn = thisTrade.legs[0].dealtStrike!;
      }
    }
  }

  const isEditable = isStrikeEditable({
    params: params,
    esid: fullTradeData?.esid,
    thisTradePassed: thisTrade,
  });

  function editableStyle() {
    if (isEditable && theme == "light") {
      return "inputCellOtherLight roundedInputCell";
    } else if (isEditable && theme == "dark") {
      return "inputCellOtherDark roundedInputCell";
    }
  }

  return (
    <div
      data-testid="StrikeCellContainer"
      id="StrikeCellContainer"
      className={`ag-roundedInputStyle justify-center text-center ${editableStyle() ?? ""}`}
      style={{ width: "100%" }}
    >
      {valueToReturn !== undefined && valueToReturn > -1
        ? returnDecimalFormatting(Number(valueToReturn), "strike") // Strike now rounded and sent in the format expected to be displayed.
        : null}
    </div>
  );
};

export default StrikeCellRenderer;
